import { render, staticRenderFns } from "./ElementIconsList.vue?vue&type=template&id=bdbdd48c"
import script from "./ElementIconsList.vue?vue&type=script&lang=js"
export * from "./ElementIconsList.vue?vue&type=script&lang=js"
import style0 from "./ElementIconsList.vue?vue&type=style&index=0&id=bdbdd48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports